import moment from "moment-timezone";
const className = ['', 'message parker', 'message stark', 'time']
const className2 = ['', 'message stark', 'message parker', 'time']
export const ListMsg = ({ message, type }) => {
  if (!message || message.length === 0) return <></>
  return <>
    {/* <div className="time">
    Today at 11:41
  </div> */}
    {message.filter(e => e.message).map((m, i) => {
      return <div className={type ? className2[m.chat_type] : className[m.chat_type]} key={i}>
        {m.username !== 'system' && <><span className="i-note-u">{m.username}</span><br/></>}
        {m.message}<br/>
        <span className="i-note-a">{moment(m.at).format('HH:mm DD/MM/YYYY')}</span>
      </div>
    })}

    {/* <div className="message stark">
      Kid, where'd you come from?
    </div>
    <div className="message parker">
      Field trip! 🤣
    </div>
    <div className="message parker">
      Uh, what is this guy's problem, Mr. Stark? 🤔
    </div>
    <div className="message stark">
      Uh, he's from space, he came here to steal a necklace from a wizard.
    </div> */}
  </>;
};
